export enum ExceptionSeverityType {
  INFO,
  WARNING,
  ERROR
}
